import React, { useState, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import { Col } from 'reactstrap';

const DatePicker = (props) => {
    const [isValid, setIsValid] = useState(true);

    const onPickerChanged = (date) => {
        const selectedDate = date?.length > 0 ? date[0] : '';
        props.changed(selectedDate);

        if (props.isMandate && !selectedDate) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    useEffect(() => {
        if (props.disable && !props.assessmentCompleted) {
            props.changed('');
        }
    }, [props.disable, props.assessmentCompleted]);

    // Placeholder text logic
    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || 'Select a date';
        if (props.isMandate) return `${placeholder} *`;
        else return placeholder;
    };

    // Calculate the date 100 years ago
    const today = new Date();
    const hundredYearsAgo = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());

    return (
        <React.Fragment>
            {props.type === 121 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <div onTouchEnd={props.handleOnBlur} className="date-picker-container datePickerInput">
                        <Flatpickr
                            className="datePickerInput"
                            value={props.value}
                            id={props?.answerInternalIdentifier}
                            onChange={onPickerChanged}
                            options={{
                                dateFormat: 'm/d/Y',
                                // maxDate: today, // Restrict future dates to today
                                minDate: hundredYearsAgo // Allow past dates up to 100 years ago
                            }}
                            disabled={props.disable}
                            style={props.disable ? { ...inputStyles, ...disabledInputStyles } : inputStyles}
                            placeholder={getPlaceholder()}
                        />
                        {/* {!isValid && props.isMandate && <p className="text-danger">This field is required.</p>} */}
                    </div>
                </Col>
            ) : (
                <div onTouchEnd={props.handleOnBlur} className="date-picker-container datePickerInput">
                    <Flatpickr
                        className="datePickerInput"
                        value={props.value}
                        id={props?.answerInternalIdentifier}
                        onChange={onPickerChanged}
                        options={{
                            dateFormat: 'm/d/Y',
                            // maxDate: today,
                            minDate: hundredYearsAgo
                        }}
                        disabled={props.disable}
                        style={props.disable ? { ...inputStyles, ...disabledInputStyles } : inputStyles}
                        placeholder={getPlaceholder()}
                    />
                    {/* {!isValid && props.isMandate && <p className="text-danger">This field is required.</p>} */}
                </div>
            )}
        </React.Fragment>
    );
};

// Styles for the input field
const inputStyles = {
    backgroundColor: '#ffffff',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    color: '#495057',
    width: '100%',
    boxSizing: 'border-box'
};

const disabledInputStyles = {
    // backgroundColor: '#e9ecef', // Light grey background for disabled state
    // cursor: 'not-allowed' // Not allowed cursor
};

export default DatePicker;
